import type { PermissionPayload } from '@Application/Security/Roles/Actions/userPermissionsFetched';
import { theme } from '@Guidelines/Theme/theme';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import PermissionRow from '@UI/Pages/Administration/Roles/RoleCard/PermissionGroup/PermissionRow';
import type RoleView from '@UI/Store/Roles/Views/RoleView';
import { css } from '@emotion/react';
import type * as React from 'react';

const groupStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
`;

const groupTitleStyle = css`
	${theme.typography.eyebrow}
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

const hintStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkFaint};
`;

const rowsStyle = css`
	display: flex;
	flex-direction: column;
`;

type Props = {
	readonly title: string;
	readonly permissions: readonly PermissionPayload[];
	readonly role: RoleView;
	/** Help text shown under the title, when the category needs one. */
	readonly hint?: string;
};

/** One permission category of the catalogue, with each of its permissions rendered as a toggle row. */
const PermissionGroup: React.FC<Props> = ({ title, permissions, role, hint }) => {
	return (
		<div css={groupStyle}>
			<div css={groupTitleStyle}>{title}</div>
			<ConditionalLoader data={hint}>{(text) => <p css={hintStyle}>{text}</p>}</ConditionalLoader>
			<div css={rowsStyle}>
				{permissions.map((permission) => (
					<PermissionRow key={permission.value} permission={permission} role={role} />
				))}
			</div>
		</div>
	);
};

export default PermissionGroup;
